/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'x2': {
    width: 16,
    height: 16,
    viewBox: '0 0 22.76 22.76',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle pid="0" class="cls-1" cx="11.38" cy="11.38" r="10.88"/><path pid="1" class="cls-2" d="M15.59 7.58l-2.72 2.73-.81.8-4.47 4.48M7.59 7.59l8 8"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/x2.js